import React from 'react'
import { t } from 'ttag'

import { Form } from 'components/shared/Form/Form'
import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { Modal } from 'components/shared/Modal/Modal'

import { NON_FIELD_ERRORS, getApiError } from 'utils/apiErrors'
import { useInternalState } from './hooks'
import { TEMPLATE_NAME_FIELD } from './model'
import { TEMPLATE_NAME_LIMIT } from './schema'

import styles from './EditInterviewTemplateNameModal.module.scss'

export const EditInterviewTemplateNameModal = ({
  templateName,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const { state, handlers } = useInternalState(
    { templateName },
    { onCancel, onClose, onConfirm },
  )

  const {
    create: { control, formState, watch },
  } = state
  const { handleCancel, handleClose, handleConfirm } = handlers

  return (
    <Modal
      className={styles.modal}
      cancelLabel={t`Cancel`}
      confirmLabel={t`Save`}
      title={t`Edit interview template name`}
      onCancel={handleCancel}
      onClose={handleClose}
      onConfirm={handleConfirm}
      isConfirmDisabled={!formState.isDirty}
      {...{ isOpen }}
    >
      <Modal.Header />
      <Modal.Content className={styles.content}>
        <MessageAlert
          className={styles.alert}
          message={t`You are editing the name of the interview template.`}
          variant="info"
          isInitialised
        />
        <Form>
          <Form.Field
            count={watch(TEMPLATE_NAME_FIELD)?.length}
            error={
              getApiError(formState.errors?.root?.apiError, NON_FIELD_ERRORS) ??
              formState.errors[TEMPLATE_NAME_FIELD]?.message
            }
            field="input"
            hint={t`Name should be unique and should not exceed 100 characters.`}
            label={t`Interview template name`}
            limit={TEMPLATE_NAME_LIMIT}
            name={TEMPLATE_NAME_FIELD}
            {...{ control }}
          />
        </Form>
      </Modal.Content>
      <Modal.Footer />
    </Modal>
  )
}
